import { faDiagramProject, faTrash, faUserCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function BowtieListItem({ title, creator, createdAt, lastModifiedAt, description, onDelete, onClick, icon }) {
  return (
    <>
      <div className='hover:border-theme/80 border border-1 p-5 pb-6 bg-white rounded-lg mt-4 shadow-lg font-dmsans'>

        <div className='flex text-slate-500'>
          <p className='text-sm mr-2'>Created at: {createdAt}</p>
          <p><svg fill="currentColor" viewBox="0 0 16 16" height="1em" width="1em"><path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" /></svg></p>
          <p className='text-sm ml-2 flex'><svg fill="currentColor" viewBox="0 0 16 16" height="16" width="16" className='mr-1'><path d="M10.97 4.97a.75.75 0 011.07 1.05l-3.99 4.99a.75.75 0 01-1.08.02L4.324 8.384a.75.75 0 111.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 01.02-.022z" /></svg>
            Updated at: {lastModifiedAt}
          </p>
        </div>

        <div className='flex justify-between mt-2 pb-4 border-b-2 border-slate-300'>
          <p className='gap-1 text-lg text-black uppercase flex font-dmsans font-semibold items-center justify-center'>{title}</p>

          <div className='flex justify-end gap-2 '>
            <button onClick={onClick} className='flex h-8 items-center p-1 px-2  bg-white rounded-lg text-black text-sm border-2 border-slate-300' >
              <svg className='mr-1 mt-0.5' viewBox="0 0 20 20" fill="currentColor" height="1em" width="1em"><path d="M.2 10a11 11 0 0119.6 0A11 11 0 01.2 10zm9.8 4a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 110-4 2 2 0 010 4z" /></svg>
              <p className='font-dmsans '>Open</p>
            </button>

            <button className='flex h-8 items-center bg-theme/90 p-1 px-2 rounded-lg text-white text-sm'>
              <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} viewBox="0 0 24 24" height="1em" width="1em" className=' mr-1 mt-0.5'><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13" /></svg>
              <p className='font-dmsans '>Share</p>
            </button>

            <button onClick={onDelete} className='flex h-8 items-center px-1 border-2 border-slate-300 rounded-lg'>
              <FontAwesomeIcon icon={faTrash} color='' size='1x' />
            </button>
          </div>
        </div>

        <div onClick={onClick} className='flex flex-col mt-2 gap-2 cursor-pointer'>

          <div className='flex items-center justify-start text-slate-700 mt-2'>
            <svg className='mr-1' viewBox="0 0 24 24" fill="currentColor" height="1em" width="1em">
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M2 3.993A1 1 0 012.992 3h18.016c.548 0 .992.445.992.993v16.014a1 1 0 01-.992.993H2.992A.993.993 0 012 20.007V3.993zM4 5v14h16V5H4zm2 2h6v6H6V7zm2 2v2h2V9H8zm-2 6h12v2H6v-2zm8-8h4v2h-4V7zm0 4h4v2h-4v-2z" />
            </svg>
            <p style={{fontFamily: 'Roboto'}} className='font-light text-sm'>Creator</p>
            <p style={{fontFamily: 'Roboto'}} className='ml-9 text-black text-sm '>
              <FontAwesomeIcon icon={faUserCircle} className='mr-1' size='1x' />
              {creator}
            </p>
          </div>
        </div>

      </div>
    </>
  )
}
